import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface CreateCorporateDefaultBillableRateDto {
  scopeOfPractice: ScopeOfPracticeEnum;

  /**
   * format: double
   * minimum: 0.01
   * maximum: 1000
   */
  hourlyRate: number;

  /**
   * format: double
   * minimum: 0.01
   * maximum: 1000
   */
  urgentHourlyRate?: number;

  scheduledRates?: CreateCorporateScheduledBillableRateDto[];
}

export interface CreateCorporateScheduledBillableRateDto {
  /**
   * format: double
   * minimum: 0.01
   * maximum: 1000
   */
  rate: number;

  /**
   * format: date-time
   */
  effectiveFrom: string;

  /**
   * format: date-time
   */
  effectiveTo: string;
}
